<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <div>
    <form-wrapper>
      @if (!form.valid && derrors) {
        <info [option]="optionInfo1">
          vous devez choisir toutes les options
        </info>
      }
      @if (organizationId != cristalisOrganizationId) {
        <electronic-signature></electronic-signature>
      }
    </form-wrapper>
    <form-footer
      [disabledNext]="isSubmitting"
      [displayNext]="'success'"
      [nextLabel]="'Terminer'"
      (prev)="prev()"
      (next)="onSubmit()"
    ></form-footer>
  </div>
</form>

@if (isSubmitting) {
  <pr-loader></pr-loader>
}

<!-- <ng-container *ngIf="products.length">

</ng-container> -->

<!-- <send-documents></send-documents> -->
<!--
<div class="grid grid-auto-height grid-col-1 grid-col-md-1 mbl">
  <ng-container *ngFor="let product of products">
    <div class="d-flex align-items-center">

      <pr-button
        display="neutral"
        size="lg"
        icon="file_open"
        label="({{ product.productName }})"
        (onClick)="openDialog()"
        class="mrxs"
      ></pr-button>
    </div>
  </ng-container>
</div>-->
